import type { IOptionItem } from '~/client/src/shared/components/OptionsList/types'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { compareLabelsAlphanumeric } from '~/client/src/shared/utils/compareGroupsByLabel'

import {
  WorkflowGroupingKey,
  WorkflowSortingKey,
} from '../WorkflowList/WorkflowList.types'

export const getWorkflowGroupingOptions = (): IOptionItem[] => {
  const options: IOptionItem[] = [
    {
      key: WorkflowGroupingKey.CATEGORY,
      label: Localization.translator.workflowCategory,
      glyph: 'workflowCategory',
    },
    {
      key: WorkflowGroupingKey.TYPE,
      label: Localization.translator.workflowType,
      glyph: 'workflowType',
    },
    {
      key: WorkflowGroupingKey.STATUS,
      label: Localization.translator.workflowStatus,
      glyph: 'workflowStatus',
    },
    {
      key: WorkflowGroupingKey.DATE,
      label: Localization.translator.date,
      glyph: 'date',
    },
    {
      key: WorkflowGroupingKey.TIME,
      label: Localization.translator.time,
      glyph: 'time',
    },
    {
      key: WorkflowGroupingKey.COMPANY,
      label: Localization.translator.responsibleCompany,
      glyph: 'company',
    },
    {
      key: WorkflowGroupingKey.CONTACT,
      label: Localization.translator.responsibleContact,
      glyph: 'contact',
    },
    {
      key: WorkflowGroupingKey.LOCATION,
      label: Localization.translator.location,
      glyph: 'location',
    },
    {
      key: WorkflowGroupingKey.EQUIPMENT,
      label: Localization.translator.equipment,
      glyph: 'equipment',
    },
    {
      key: WorkflowGroupingKey.MATERIAL,
      label: Localization.translator.material,
      glyph: 'material',
    },
    {
      key: WorkflowGroupingKey.FILE_TYPE,
      label: Localization.translator.fileType,
      glyph: 'fileType',
    },
    {
      key: WorkflowGroupingKey.PROJECT,
      label: Localization.translator.project,
      glyph: 'project',
    },
  ]
  return options.sort((a, b) => compareLabelsAlphanumeric(a.label, b.label))
}

export const getWorkflowSortingOptions = (): IOptionItem[] => {
  const options: IOptionItem[] = [
    {
      key: WorkflowSortingKey.NAME,
      label: Localization.translator.workflowName,
      glyph: 'name',
    },
    ...getWorkflowGroupingOptions()
      .filter(opt => opt.key !== WorkflowGroupingKey.TIME)
      .map(opt => ({
        ...opt,
        key: opt.key as WorkflowSortingKey,
      })),
  ]
  return options.sort((a, b) => compareLabelsAlphanumeric(a.label, b.label))
}
